import React, { useState, useEffect } from "react";
import styles from "./Cotizaciones.module.scss";
import styled from "styled-components";
import NewNavImproved from "../../components/Nav/NewNavImproved.tsx";
import BotoneraModern from "../../components/Botonera/BotoneraModern.tsx";
import CalculadoraDeMateriales from "../../components/MarketPlace/CalculadoraDeMateriales/CalculadoraDeMateriales";
import Breadcrumbs from "../../components/UI/Breadcrumbs/Breadcrumbs.tsx";
import useNavVisibility from "../../hooks/useNavVisibility.ts";

const Container = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding-right: 5%;
    padding-left: 5%;
    max-width: 150rem;
        margin: auto;
    
    @media (max-width: 1200px) {
        padding-right: 5%;
        padding-left: 5%;
    }
    
    @media (max-width: 900px) {
        padding-right: 0;
        padding-left: 0;
    }
    `;

const Cotizaciones = () => {

    const { ocultarEnMobile, mobileStylesFromParent } = useNavVisibility();


    return (
        <Container>
            {!ocultarEnMobile && <NewNavImproved />}
            {ocultarEnMobile && <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} />}
            <div className={styles.container}>
                <div className={styles.breadcrumbContainer}>
                    <Breadcrumbs />
                </div>
                <CalculadoraDeMateriales />
            </div>
        </Container>
    );
};

export default Cotizaciones;